<template>
  <div class="l-audio-circle" v-if="circles&&circles.length>0">
    <div class="l-circle" :class="{'isActive':item.active}" v-for="(item,index) in circles" :key="index"></div>
  </div>
</template>

<script>
export default {
  name: "l-audio-circle",
  data() {
    return {
      circles:[],
    };
  },
  methods: {
      //获取1-511的5个随机数
      onGetRandom(){
          return [Math.floor(Math.random()*(1 - 511) + 511)-1,Math.floor(Math.random()*(1 - 511) + 511)-1,Math.floor(Math.random()*(1 - 511) + 511)-1,Math.floor(Math.random()*(1 - 511) + 511)-1,Math.floor(Math.random()*(1 - 511) + 511)-1]
      },
      initCircle(){
        for (let index = 0; index < 512; index++) {
                this.circles.push({
                    'num':index,
                    'active':false
                }) 
            }
      },
      onActive(){
         let arr = this.onGetRandom();
         for (let index = 0; index < arr.length; index++) {
             const element = arr[index];
             this.circles[element].active = true;
         }
      }
  },
  mounted() {
      this.initCircle();
      setInterval(()=>{
        this.circles = [];
        this.initCircle();
        this.onActive();
      },1000)
  },
};
</script>

<style lang="stylus" scoped>
@import './index.styl';
</style>
